import { render, staticRenderFns } from "./IconClear.vue?vue&type=template&id=046bd1fb&functional=true"
import script from "./IconClear.vue?vue&type=script&lang=js"
export * from "./IconClear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports